export const LOAD_RESULTS_EMPLOYEE_FOR_REFEREE = 'LOAD_RESULTS_EMPLOYEE_FOR_REFEREE';
export const CLEAN_RESULTS_EMPLOYEE_FOR_REFEREE = 'CLEAN_RESULTS_EMPLOYEE_FOR_REFEREE';
export const SEARCH_RESULTS_EMPLOYEE_FOR_REFEREE = 'SEARCH_RESULTS_EMPLOYEE_FOR_REFEREE';
